import { useEffect } from 'react';

import { sendHotJarEvent } from 'src/hooks/useHotjarEvent';

import { CareerFeedAiAssistantInitialState } from '../CareerFeedAiAssistantInitialState/CareerFeedAiAssistantInitialState';
import { CareerFeedAssistantQuestions } from '../CareerFeedAssistantQuestions/CareerFeedAssistantQuestions';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import { RecommendationRefinedConfirmation } from './CareerFeedAIAssistantRecommendationRefinedConfirmation';
import { ConversationFinished } from './ConversationFinished';

export const CareerFeedAIAssistantContent = () => {
  const {
    sequence,
    progress,
    tracking: {
      trackGenAIChatOutputDisplayed,
      trackGenAIChatStarted,
      trackGenAIChatCtaDisplayed,
    },
  } = useCareerFeedAIAssistant();

  useEffect(() => {
    if (progress === 'initial') {
      trackGenAIChatCtaDisplayed();
      sendHotJarEvent('homepage_genAI_start');
    } else if (progress !== 'recsRefined-withPersistedData') {
      trackGenAIChatOutputDisplayed();
    }

    if (sequence === 1) {
      trackGenAIChatStarted();
    }
  }, [
    progress,
    sequence,
    trackGenAIChatCtaDisplayed,
    trackGenAIChatOutputDisplayed,
    trackGenAIChatStarted,
  ]);

  switch (progress) {
    case 'initial':
      return <CareerFeedAiAssistantInitialState />;
    case 'recsRefined':
      return <ConversationFinished />;
    case 'recsRefined-withPersistedData':
      return <RecommendationRefinedConfirmation />;
    case 'gatheringRefinement':
    case 'collectGeneralRequirementsAtLast':
      return <CareerFeedAssistantQuestions />;
  }
};
